import request from "utils/request";

export async function getMyWeakness() {
  return request.get("/portrait/myWeakness.php", "nocache");
}

export async function getMyRecommend(courseLevel) {
  return request.get(
    `/portrait/recommend.php?course_level=${courseLevel}`,
    "nocache"
  );
}

export async function getMyTips() {
  return request.get("/portrait/tip.php", "nocache");
}
